import Overview from "../../Pages/Overview";
import Team from "../../Pages/Team";
import {
  IconBook,
  IconChalkboard,
  IconCreditCard,
  IconHome,
  IconNotebook,
  IconReceipt,
  IconSchool,
  IconUserCircle,
  IconUsers,
} from "@tabler/icons-react";
import { AdminScopeValueProps } from "../types";

interface RouteProps {
  path: string;
  label: string;
  icon: typeof IconHome;
  scopes: AdminScopeValueProps[];
}
export const RouteList: RouteProps[] = [
  {
    path: "/d/overview",
    label: "Overview",
    icon: IconHome,
    scopes: [],
  },
  {
    path: "/d/team",
    label: "Team",
    icon: IconUsers,
    scopes: ["modify_student"],
  },
  {
    path: "/d/plans",
    label: "Plans",
    icon: IconCreditCard,
    scopes: ["modify_plan"],
  },
  {
    path: "/d/courses",
    label: "Courses",
    icon: IconBook,
    scopes: ["modify_course"],
  },
  {
    path: "/d/students",
    label: "Students",
    icon: IconSchool,
    scopes: ["modify_student"],
  },
  {
    path: "/d/billing",
    label: "Billing",
    icon: IconReceipt,
    scopes: ["modify_transaction"],
  },
];
